import { ReactComponent as Icon } from "../images/arrowed-2.svg";

const UploadPdf  = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default UploadPdf;
